import { useEffect, useRef } from 'react';
import { hasChangesSinceBaseline } from './slideOverUnsavedChanges';

const BASELINE_STABILIZE_MS = 400;

const useSlideOverBaseline = ({
  getSnapshot,
  deps,
  setSlideOverHasUnsavedChanges,
  // A panel that loads its values (modification) waits for them: a baseline
  // taken on the empty form would count the loaded values as changes.
  isReady = true,
}) => {
  const baselineRef = useRef(null);
  const baselineReadyRef = useRef(false);
  const currentSnapshotRef = useRef(null);

  currentSnapshotRef.current = getSnapshot();

  useEffect(() => {
    return () => {
      baselineRef.current = null;
      baselineReadyRef.current = false;
      setSlideOverHasUnsavedChanges(false);
    };
  }, [setSlideOverHasUnsavedChanges]);

  useEffect(() => {
    if (baselineReadyRef.current || !isReady) return;

    const timeoutId = window.setTimeout(() => {
      baselineRef.current = currentSnapshotRef.current;
      baselineReadyRef.current = true;
      setSlideOverHasUnsavedChanges(false);
    }, BASELINE_STABILIZE_MS);

    return () => window.clearTimeout(timeoutId);
  }, [...deps, isReady, setSlideOverHasUnsavedChanges]);

  useEffect(() => {
    if (!baselineReadyRef.current || !baselineRef.current) return;

    setSlideOverHasUnsavedChanges(
      hasChangesSinceBaseline(
        currentSnapshotRef.current,
        baselineRef.current
      )
    );
  }, [...deps, setSlideOverHasUnsavedChanges]);
};

export default useSlideOverBaseline;
